import type { KeyboardEvent, MouseEvent, PointerEvent } from "react";

/*
 * Opening a record from a table row, like ServiceM8's lists: a click selects the row (focuses its
 * button), a double-click opens it. Enter opens it from the keyboard, and on a touch screen
 * (where double-tap isn't reliable) a tap opens it. Spread onto the row's button.
 */

let lastPointer = "mouse";

export function rowOpen(open: () => void) {
    return {
        title: "Double-click to open",
        onPointerDown: (e: PointerEvent) => {
            lastPointer = e.pointerType;
        },
        onClick: (e: MouseEvent<HTMLButtonElement>) => {
            if (lastPointer === "touch") open();
            else e.currentTarget.focus();
        },
        onDoubleClick: () => {
            if (lastPointer !== "touch") open();
        },
        onKeyDown: (e: KeyboardEvent) => {
            if (e.key !== "Enter") return;
            e.preventDefault();
            open();
        },
    };
}
